import { categories } from '@/mocks/bookData';

export default function Categories() {
  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
            <i className="ri-grid-line"></i>
            题材分类
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            按题材找到你的菜
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            从玄幻仙侠到游戏竞技，八大题材分类汇集海量人气作品，跟随同好脚步，少走弯路。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#ranking"
              className="group flex flex-col rounded-xl bg-background-50 p-5 transition hover:bg-accent-50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900 transition group-hover:bg-accent-100 group-hover:text-accent-800">
                <i className={`text-xl ${c.icon}`}></i>
              </span>
              <div className="mt-4 flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{c.name}</h3>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{c.count}</span>
              </div>
              <p className="mt-1 text-xs text-foreground-600">{c.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-700 opacity-0 transition group-hover:opacity-100 whitespace-nowrap">
                浏览该分类 <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}